export default __webpack_public_path__ + "static/media/scooter-title-mb@2x.25037659.png";